export const html5ConfigBlock = ['$locationProvider', $locationProvider => { 
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
}];


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/ap.config.ts